import 'css-chunksrc/client/pages/exportsPage/timesheetByTaskReport/viewSelect/styles.scss';export default {
  "dataTypeFilter": "_dataTypeFilter_q9jgo_1",
  "input": "_input_q9jgo_7",
  "toggleArrow": "_toggleArrow_q9jgo_23",
  "selectedDataTypes": "_selectedDataTypes_q9jgo_31",
  "placeholder": "_placeholder_q9jgo_40",
  "list": "_list_q9jgo_45",
  "item": "_item_q9jgo_57",
  "typeName": "_typeName_q9jgo_70",
  "opened": "_opened_q9jgo_77"
};